module.exports = __webpack_public_path__ + "img/code-analyzer00.6078a2b4.gif";